function decodeToken(): Record<string, any> | null {
  const token = localStorage.getItem('auth_token');
  if (!token) return null;
  const payload = token.split('.')[1];
  if (!payload) return null;
  try {
    return JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
  } catch {
    return null;
  }
}

export function getCurrentUserRole(): string | null {
  return decodeToken()?.role ?? null;
}

export function getCurrentUserId(): string | null {
  return decodeToken()?.sub ?? null;
}

export function getMustChangePassword(): boolean {
  return decodeToken()?.mustChangePassword === true;
}
